import { creatorCategories } from "@/mocks/creatorDirectory";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-900 px-4 pt-16 pb-8 text-secondary-100 md:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-clapperboard-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                西瓜视频网红名单
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-secondary-200">
              一页看懂西瓜视频的创作者生态：头部大V、优质达人与潜力新人各有什么看点，
              想找对味博主、追踪热门网红，都可以从这里开始。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              <span className="rounded-full border border-secondary-700 px-3 py-1 text-xs text-secondary-200">
                创作者生态
              </span>
              <span className="rounded-full border border-secondary-700 px-3 py-1 text-xs text-secondary-200">
                主播与大V
              </span>
              <span className="rounded-full border border-secondary-700 px-3 py-1 text-xs text-secondary-200">
                达人速览
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold uppercase tracking-wide text-background-50">
              页面导航
            </h3>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                { href: "#overview", label: "平台生态速览" },
                { href: "#creators", label: "创作者速览" },
                { href: "#ranking", label: "编辑精选榜" },
                { href: "#rising", label: "新锐力量" },
                { href: "#guide", label: "选博主指南" },
                { href: "#faq", label: "常见问题" },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-secondary-200 transition-colors hover:text-primary-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold uppercase tracking-wide text-background-50">
              内容领域
            </h3>
            <ul className="mt-5 flex flex-wrap gap-2">
              {creatorCategories.map((cat) => (
                <li key={cat.key}>
                  <a
                    href="#creators"
                    className="inline-block rounded-md border border-secondary-700 px-2.5 py-1 text-xs text-secondary-200 transition-colors hover:border-primary-400 hover:text-primary-300"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-secondary-700 pt-6">
          <p className="text-xs leading-relaxed text-secondary-300">
            本页为创作者生态的整理与速览，便于浏览与查找，不代表平台官方立场；相关账号信息会随时间变化，请以平台实时信息为准。
          </p>
          <p className="mt-3 text-xs text-secondary-300">
            © {year} 西瓜视频网红名单 · 内容速览整理
          </p>
        </div>
      </div>
    </footer>
  );
}